"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReplay = void 0;
var React = __importStar(require("react"));
var IconReplay = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M2,3.1289 C2,2.5329 2.484,2.0509 3.078,2.0509 C3.672,2.0509 4.156,2.5329 4.156,3.1329 L4.156,6.5579 C4.797,5.5239 5.637,4.6069 6.621,3.8809 C8.293,2.6499 10.281,1.9999 12.375,1.9999 C14.941,1.9999 17.355,2.9869 19.176,4.7749 C20.996,6.5659 22,8.9559 22,11.4959 C22,14.0359 20.996,16.4269 19.172,18.2259 C17.355,20.0169 14.941,20.9999 12.371,20.9999 C10.23,20.9999 8.207,20.3219 6.516,19.0399 C4.875,17.7939 3.66,16.0299 3.105,14.0749 C2.941,13.4989 3.273,12.9029 3.844,12.7379 C4.414,12.5739 5.012,12.9069 5.176,13.4829 C6.074,16.6379 9.031,18.8409 12.371,18.8409 C16.492,18.8409 19.844,15.5489 19.844,11.4999 C19.844,7.4509 16.492,4.1549 12.375,4.1549 C9.547,4.1549 7.031,5.6879 5.758,8.0739 L8.953,8.0739 C9.547,8.0739 10.031,8.5609 10.031,9.1559 C10.031,9.7519 9.547,10.2379 8.953,10.2379 L3.078,10.2339 C2.965,10.2339 2.859,10.2189 2.758,10.1839 C2.336,10.0579 2.023,9.6739 2,9.2109 L2,9.1559 L2,3.1289 Z" }))); };
exports.IconReplay = IconReplay;
exports.IconReplay.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconReplay;
